import { createAction, props, union } from '@ngrx/store';
import { RfrSaveQueryI } from 'src/app/api/rfr-save/rfr-save.query.int';
import { RfrSaveI } from 'src/app/api/rfr-save/rfr-save.result.int';
/* eslint-disable max-len */

export const error = createAction('[RFR / Save] Error', props<{ messageText: string }>());
export const reset = createAction('[RFR / Save] Reset', props<Record<string, unknown>>());
export const load = createAction('[RFR / Save] Get', props<{ query: RfrSaveQueryI }>());
export const received = createAction('[RFR / Save] Received', props<{ data: RfrSaveI }>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
